<template>
    <tr>
        <td>
            <v-select
                :items="productTypes"
                item-value="id"
                item-text="text"
                v-model="internalValue.type"
                :error-messages="errorMessages(`products.${index}.type`)"
                :class="{ 'error--text': hasErrors(`products.${index}.type`) }"
                class="primary--text"
                :name="`products.${index}.type`"
                label="Tip produs"
                data-vv-as="Tip produs"
                :data-vv-name="`products.${index}.type`"
            />
        </td>
        <td>
            <product-combo-box
                v-model="internalValue.id"
                :initial-items="[internalValue]"
                :field-errors="errorMessages(`products.${index}.name`)"
                @change="handleProductLineChange($event)"
            />
        </td>
        <td>
            <v-offer-row-field
                v-model="internalValue.product_number"
                :error-messages="errorMessages(`products.${index}.product_number`)"
                :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.product_number`) }"
                data-vv-as="Cod produs"
                :data-vv-name="`products.${index}.product_number`"
            />
        </td>
        <td>
            <v-offer-row-field
                v-model="internalValue.quantity"
                :error-messages="errorMessages(`products.${index}.quantity`)"
                :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.quantity`) }"
                data-vv-as="Cantitate"
                :data-vv-name="`products.${index}.quantity`"
                type="number"
            />
        </td>
        <td>
            <v-select
                :items="productMeasurements"
                v-model="internalValue.measurement"
                :error-messages="errorMessages(`products.${index}.measurement`)"
                :class="{ 'error--text': hasErrors(`products.${index}.measurement`) }"
                class="primary--text input-text-right"
                :name="`products.${index}.measurement`"
                label="U.M."
                data-vv-as="U.M."
                :data-vv-name="`products.${index}.measurement`"
            />
        </td>
        <td>
            <v-offer-row-field
                v-model="internalValue.unit_price"
                :error-messages="errorMessages(`products.${index}.unit_price`)"
                :class="{ 'primary--text input-text-right':true, 'error--text': hasErrors(`products.${index}.unit_price`) }"
                data-vv-as="Pret unitar ofertat"
                :data-vv-name="`products.${index}.unit_price`"
                type="number"
            />
        </td>
        <td>
            <v-btn
                :disabled="!canEdit"
                class="ma-2 pull-right"
                color="error"
                outlined
                x-small
                fab
                @click="$emit('delete')"
            >
                <v-icon>mdi-trash-can</v-icon>
            </v-btn>
        </td>
    </tr>
</template>

<script>
import ProductComboBox from 'Components/common/ProductComboBox'
export default {
    name: 'VOfferRow',
    components: {
        ProductComboBox
    },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    id: null,
                    type: null,
                    name: null,
                    product_number: null,
                    quantity: 1,
                    measurement: 'BUC',
                    unit_price: 0,
                }
            }
        },
        index: {
            type: Number,
            default() {
                return null
            }
        },
        canEdit: {
            type: Boolean,
            default() {
                return true
            }
        },
        hasErrors: {
            type: Function,
            default () {
                return () => {

                }
            }
        },
        errorMessages: {
            type: Function,
            default () {
                return () => {

                }
            }
        }
    },
    watch: {
        value: {
            handler (val) {
                this.internalValue = val
            },
            deep: true
        },
        internalValue: {
            handler (val) {
                this.$emit('input', val)
            },
            deep: true
        }
    },
    data () {
        return {
            internalValue: this.value,
            productTypes: [{
                id: 'PRODUCT',
                text: 'Produs'
            },{
                id: 'SERVICE',
                text: 'Serviciu'
            }],
            productMeasurements: [],
        }
    },
    methods: {
        handleProductLineChange(ev) {
            if (!this._.isNil(ev)) {
                if (ev instanceof Object) {
                    this.internalValue.id = ev.id
                    this.internalValue.type = ev.type
                    this.internalValue.name = ev.name
                    this.internalValue.product_number = ev.product_number
                } else {
                    if (!this._.isNil(this.internalValue.id)) {
                        this.internalValue.id = null
                        this.internalValue.type = null
                        this.internalValue.product_number = null
                    }
                    this.internalValue.name = ev
                }
                this.$validator.reset();
                this.$validator.validateAll()
            }
        }
    },
    async mounted() {
        this.productMeasurements = (new this.$db.OfferProduct).measurements
    }
    /*
    beforeUpdate() {
        console.log('beforeUpdate', this.index)
    },
    updated() {
        console.log('updated', this.index)
    }
    */
}
</script>
